export default [
  {
    path: '/buses',
    name: 'buses.index',
    component: () => import('@/views/buses/BusesIndex.vue'),
    meta: {
      requiresAuth: true,
      title: 'buses.breadcrumbs.buses',
      requiredPerm: 'buses.display'
    },
    children: [
      {
        path: 'create',
        name: 'buses.create',
        component: () => import('@/views/buses/BusForm.vue'),
        meta: {
          requiresAuth: true,
          title: 'buses.breadcrumbs.addBus',
          requiredPerm: 'buses.create'
        }
      },
      {
        path: ':id/edit',
        name: 'buses.edit',
        component: () => import('@/views/buses/BusForm.vue'),
        props: true,
        meta: {
          requiresAuth: true,
          title: 'buses.breadcrumbs.editBus',
          requiredPerm: 'buses.update'
        }
      },
      {
        path: ':id/areas',
        name: 'buses.areas',
        component: () => import('@/views/buses/BusAreasManagement.vue'),
        props: true,
        meta: {
          requiresAuth: true,
          title: 'buses.breadcrumbs.areas',
          requiredPerm: 'buses.display'
        }
      },
      {
        path: ':id/subscribers',
        name: 'buses.subscribers',
        component: () => import('@/views/buses/BusSubscribers.vue'),
        props: true,
        meta: {
          requiresAuth: true,
          title: 'buses.breadcrumbs.subscribers',
          requiredPerm: 'buses.display'
        }
      },

{
  path: ':id/payments',
  name: 'buses.payments',
  component: () => import('@/views/buses/BusPayments.vue'), 
  props: true,
    meta: {
      requiresAuth: true,
      title: 'buses.breadcrumbs.payments',
      requiredPerm: 'buses.display'
    }
},
{
  path: 'subscribe',
  name: 'buses.subscribe',
  component: () => import('@/views/buses/BusSubscriptionPage.vue'),
  title: 'buses.subscribe.pageTitle',
  props: route => ({ prefillBusId: route.query.bus_id || null }),
    meta: {
      requiresAuth: true,
      title: 'buses.subscribe.pageTitle',
      requiredPerm: 'bus_subscriptions.create'  
    }
}
  
    ]
},

];
